import Vue from "vue";
import App from "./App.vue";

import vuetify from "./plugins/vuetify";
// import VueAnalytics from "vue-analytics";

import store from "./store";

import "./styles/app.scss";
import "./styles/animations.scss";
import './registerServiceWorker'

Vue.config.productionTip = false;

// Vue.use(VueAnalytics, {
//   id: "G-FNGSZQ0YJ9",
// });

new Vue({
  store,
  vuetify,
  render: (h) => h(App),
}).$mount("#app");
